import { render, staticRenderFns } from "./TeacherManage.vue?vue&type=template&id=717ac8f3&scoped=true"
import script from "./TeacherManage.vue?vue&type=script&lang=js"
export * from "./TeacherManage.vue?vue&type=script&lang=js"
import style0 from "./TeacherManage.vue?vue&type=style&index=0&id=717ac8f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717ac8f3",
  null
  
)

export default component.exports